import type { FC } from 'react';
import { Inline } from '@george-labs.com/design-system';

import { formatPercentage } from '@shared/formatting-utils';

import type { CommonItemProps } from './types';
import { ProductsListItemWrapper } from '../ProductsListItemWrapper';

type Props = CommonItemProps & {
    percentage: number;
    bold?: boolean;
    decimals?: number;
    shouldRound?: boolean;
};

export const ProductsListPercentageItem: FC<Props> = ({
    'data-cy': dataCy,
    className,
    label,
    labelClassName,
    labelColumnWidth,
    percentage,
    bold = false,
    decimals,
    shouldRound,
}) => (
    <ProductsListItemWrapper
        data-cy={dataCy}
        className={className}
        label={label}
        labelClassName={labelClassName}
        labelColumnWidth={labelColumnWidth}
    >
        <Inline data-cy={dataCy} emphasis={bold}>
            {formatPercentage(percentage, true, decimals, shouldRound)}
        </Inline>
    </ProductsListItemWrapper>
);
